var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import { Grid, GridColumn } from "@atlassiansox/microscopekit";
import Button, { ButtonGroup } from "@atlaskit/button";
import SectionMessage from "@atlaskit/section-message";
import AddIcon from "@atlaskit/icon/glyph/add";
import DownloadIcon from "@atlaskit/icon/glyph/download";
import { useHistory } from "react-router-dom";
import { isEmpty } from "lodash";
import { WargamePlanCard } from "../WargamePlanCard";
export var WargamePlans = function (_a) {
    var wargamePlans = _a.wargamePlans, wargameExerciseId = _a.wargameExerciseId, onAddWargamePlan = _a.onAddWargamePlan, isExecutionAllowed = _a.isExecutionAllowed, isExerciseActive = _a.isExerciseActive, isWargameActive = _a.isWargameActive;
    var history = useHistory();
    var onCreateWargamePlan = function () {
        history.push("../create-template?wargameExerciseId=" + wargameExerciseId);
    };
    return (React.createElement("div", null,
        React.createElement(Header, null,
            React.createElement("h3", null, "Wargame Plans"),
            React.createElement(ButtonGroup, null,
                React.createElement(Button, { appearance: "primary", iconBefore: React.createElement(DownloadIcon, { label: "import" }), onClick: onAddWargamePlan, isDisabled: !isExerciseActive }, "Import Plan"),
                React.createElement(Button, { appearance: "primary", iconBefore: React.createElement(AddIcon, { label: "add", size: "small" }), onClick: onCreateWargamePlan, isDisabled: !isExerciseActive }, "Create Plan"))),
        React.createElement("br", null),
        isEmpty(wargamePlans) ? (React.createElement(SectionMessage, { title: "No wargame plans added!" }, "You can import existing plans or create new plans")) : (React.createElement(Grid, null, wargamePlans.map(function (wargamePlan) { return (React.createElement(GridColumn, { key: wargamePlan.id, medium: 4 },
            React.createElement(WargamePlanCard, { wargamePlan: wargamePlan, wargameExerciseId: wargameExerciseId, isExecutionAllowed: isExecutionAllowed, isExerciseActive: isExerciseActive, isWargameActive: isWargameActive }))); })))));
};
var Header = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  gap: 2rem;\n"], ["\n  display: flex;\n  align-items: center;\n  gap: 2rem;\n"])));
var templateObject_1;
